<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            Notes
        </div>
        <div class="panel-body">
            <button class="btn btn-primary">
                <router-link :to="{ name: 'neworedit', params: { id: 0 }}">Nieuw</router-link>
            </button>
            <br />&nbsp;<br />
            <table class="table table-bordered table-hover">
                <tr v-for="note in notes">
                    <td><router-link :to="{ name: 'neworedit', params: { id: note.id }}">{{ note.title }}</router-link></td>
                    <td>{{ note.text }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "invoer",
        data () {
            return {
                notes: null
            }
        },
        mounted() {
            axios.get('/releasenote').then(response => {
                console.log(response)
                if (response.data.error) {
                    alert(response.data.error)
                } else if (response.data.result) {
                    this.notes = response.data.result
                }
            });
        }
    }
</script>

<style scoped>

</style>